/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetHooksStatusSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type GetHooksStatusSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type GetHooksStatusSecurity = {
  option1?: GetHooksStatusSecurityOption1 | undefined;
  option2?: GetHooksStatusSecurityOption2 | undefined;
};

export type GetHooksStatusRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type GetHooksStatusSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const GetHooksStatusSecurityOption1$outboundSchema: z.ZodMiniType<
  GetHooksStatusSecurityOption1$Outbound,
  GetHooksStatusSecurityOption1
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function getHooksStatusSecurityOption1ToJSON(
  getHooksStatusSecurityOption1: GetHooksStatusSecurityOption1,
): string {
  return JSON.stringify(
    GetHooksStatusSecurityOption1$outboundSchema.parse(
      getHooksStatusSecurityOption1,
    ),
  );
}

/** @internal */
export type GetHooksStatusSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const GetHooksStatusSecurityOption2$outboundSchema: z.ZodMiniType<
  GetHooksStatusSecurityOption2$Outbound,
  GetHooksStatusSecurityOption2
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function getHooksStatusSecurityOption2ToJSON(
  getHooksStatusSecurityOption2: GetHooksStatusSecurityOption2,
): string {
  return JSON.stringify(
    GetHooksStatusSecurityOption2$outboundSchema.parse(
      getHooksStatusSecurityOption2,
    ),
  );
}

/** @internal */
export type GetHooksStatusSecurity$Outbound = {
  Option1?: GetHooksStatusSecurityOption1$Outbound | undefined;
  Option2?: GetHooksStatusSecurityOption2$Outbound | undefined;
};

/** @internal */
export const GetHooksStatusSecurity$outboundSchema: z.ZodMiniType<
  GetHooksStatusSecurity$Outbound,
  GetHooksStatusSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => GetHooksStatusSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => GetHooksStatusSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function getHooksStatusSecurityToJSON(
  getHooksStatusSecurity: GetHooksStatusSecurity,
): string {
  return JSON.stringify(
    GetHooksStatusSecurity$outboundSchema.parse(getHooksStatusSecurity),
  );
}

/** @internal */
export type GetHooksStatusRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const GetHooksStatusRequest$outboundSchema: z.ZodMiniType<
  GetHooksStatusRequest$Outbound,
  GetHooksStatusRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
    });
  }),
);

export function getHooksStatusRequestToJSON(
  getHooksStatusRequest: GetHooksStatusRequest,
): string {
  return JSON.stringify(
    GetHooksStatusRequest$outboundSchema.parse(getHooksStatusRequest),
  );
}
